<mat-form-field
  [attr.data-cy]="'customer-multi-select'"
  *ngIf="selectedCustomerIds$ | async as selectedCustomerIds">
  <mat-label *ngIf="selectedCustomerIds.length">{{
    ("agency" | i18n) || "Vermittler" | titlecase
  }}</mat-label>
  <mat-label *ngIf="selectedCustomerIds.length === 0">{{
    ("all_agencies" | i18n) || "Alle Vermittler" | titlecase
  }}</mat-label>
  <mat-chip-list
    #customerList
    [disabled]="!!(isDisabled$ | async)">
    <mat-chip
      *ngFor="let selectedCustomer of selectedCustomers$ | async"
      [attr.data-cy]="'selected-customer-' + selectedCustomer._id">
      {{ selectedCustomer.name }}
      <mat-icon
        matChipRemove
        *ngIf="!(isDisabled$ | async)"
        data-cy="remove-certificate"
        svgIcon="close-circle"
        (click)="removeSelectedCustomer(selectedCustomer._id)">
      </mat-icon>
    </mat-chip>
    <input
      #searchTermInputElement
      name="CustomerMultiSelectSearch"
      #trigger="matAutocompleteTrigger"
      [matAutocomplete]="customerAutoComplete"
      [matChipInputFor]="customerList"
      [formControl]="searchTermControl" />
  </mat-chip-list>
  <mat-autocomplete
    #customerAutoComplete="matAutocomplete"
    autoActiveFirstOption
    (optionSelected)="matInputSelect($event, trigger)">
    <mat-option
      *ngFor="let customer of filteredCustomers$ | async"
      [attr.data-cy]="'department-select-option-' + customer._id"
      [value]="customer._id">
      <span class="customer-multiselect-option">
        {{ customer.name }}
        <mat-icon
          *ngIf="selectedCustomerIds.includes(customer._id)"
          svgIcon="check"></mat-icon>
      </span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
